import { render } from "./valuation-card.vue?vue&type=template&id=9acdcc04"
import script from "./valuation-card.js?vue&type=script&lang=js"
export * from "./valuation-card.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__